<div class="profile-container">
  <div class="">
    <div class="profile-content">

      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">
            <select style="text-align: center;margin-bottom: 0;margin-right: 10px;" name="" id=""
              [(ngModel)]="objectStatus" (change)="getObjectAllocationRegisterByStatusWithPagination(0,10,objectStatus)"
              class="form-control">
              <option value="{{list.key}}" style="text-transform: capitalize;" *ngFor="let list of statusListInfo">
                {{list.value}}</option>
            </select>
            <div class="search">
              <form autocomplete="off">
                <input type="text"
                  (keyup.enter)="getAllObjectAllocationRegistersByWildSearchWithPagination(0,10,searchFilter)"
                  [ngModelOptions]="{standalone: true}" placeholder="search" [(ngModel)]="searchFilter">
              </form>
              <i class="bi bi-search"
                (click)="getAllObjectAllocationRegistersByWildSearchWithPagination(0,10,searchFilter)"></i>
            </div>
            <button data-toggle="modal" *ngIf="actionControls.isAdd" title="Add" data-target="#deviceModal"><i
                class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
            <div class="filter-icon">
              <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
            </div>
          </div>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>

              <th style="width: 10%;">{{ 'object-allocation-register.objectAllocationRegisterId' | translate }}</th>
              <th style="width: 20%;">{{ 'object-allocation-register.givenName' | translate }}</th>
              <th style="width: 15%;">{{ 'object-allocation-register.requestedByUserName' | translate }}</th>
              <th style="width: 15%;">{{ 'object-allocation-register.requestedQuantity' | translate }} </th>
              <th style="width: 15%;">{{ 'object-allocation-register.latestStatus' | translate }} </th>
              <th style="width: 15%;">{{ 'object-allocation-register.requestedDate' | translate }}</th>
              <!-- <th style="width: 10%;">Status</th> -->
              <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
            </tr>
          </thead>
        </table>
        <div *ngIf="!isLoading">
          <div class="data-view" id="{{list.id}}"
            [ngClass]="{ 'delete-highlight': list.objectAllocationRegisterId == recordId }" *ngFor="let list of objectAllocationRegisterList | paginate : {
                          itemsPerPage: tableSize,
                          currentPage: page,
                          totalItems: count
                        }  ;let i = index">

            <p style="width: 10%;">{{list.objectAllocationRegisterId}}</p>
            <p style="width: 20%;">{{list.objectTemplateName}}</p>
            <p style="width: 15%;">{{list.requestedByUserName}}</p>
            <p style="width: 15%;">{{list.requestedQuantity || '--'}}</p>
            <p style="width: 15%;">{{ getStatus(list.latestStatus)}}</p>
            <p style="width: 15%;"><span *ngIf="list.requestedDate != 0">{{list.requestedDate | date }}</span> </p>
            <!-- <p style="width: 10%;">{{list.latestStatus }}</p> -->


            <p class="action-buttons" style="width: 10%;padding-left: 25px;">
              <i data-toggle="modal" *ngIf="actionControls.isView" title="View"
                (click)="getObjectAllocationRegisterById(list.objectAllocationRegisterId)" data-target="#viewModal"
                class="bi bi-eye-fill"></i>
              <i *ngIf="actionControls.isDelete" (click)="selectDelete(list.id,list)" title="Delete" class="bi bi-trash"
                data-toggle="modal" data-target="#deleteModal"></i>
            </p>
          </div>
        </div>


        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>

        <div class="loader" *ngIf="!isLoading && objectAllocationRegisterList.length == 0">
          <div class="no-data">
            <img src="assets/no-data-6.png" alt="">
            <p>no data found</p>
          </div>

        </div>

        <div class="paginator">
          <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
            [totalRecords]="count" [showFirstLastIcon]="true" [showCurrentPageReport]="true" [showPageLinks]="true"
            [showJumpToPageDropdown]="false" currentPageReportTemplate="{first} - {last} of {totalRecords}">
          </p-paginator>
        </div>


      </div>
    </div>
  </div>
</div>





<div class="modal fade" id="deviceModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-allocation-register.headings.add' | translate }}
          <span data-dismiss="modal" (click)="remove()">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="row form-group" [formGroup]="form">

          <div class="col-lg-6 col-md-6">
            <label>Asset <span class="required">*</span></label>
            <select name="" id="" formControlName="objectTemplateName" class="form-control">
              <option value="" selected disabled> -- select asset --</option>
              <option value="{{list.name}}" *ngFor="let list of objectTemplateList">{{list.name}}</option>
            </select>
          </div>

          <div class="col-lg-6 col-md-6">
            <label>Location <span class="required">*</span></label>
            <select name="" id="" formControlName="location" class="form-control">
              <option value="" selected disabled> -- select location --</option>
              <option value="{{list.zone}}" *ngFor="let list of locationList">{{list.zone}}</option>
            </select>
          </div>

          <div [ngClass]="isRequestedUOM ? 'col-lg-6 col-md-6' : 'col-lg-12 col-md-12'">
            <label>Quantity <span class="required">*</span></label>
            <input type="number" (drop)="false" (copy)="false" (paste)="false" (contextmenu)="$event.preventDefault()"
              (cut)="false" (keydown)="filterInputByType($event, 'number')" formControlName="requestedQuantity"
              class="form-control">
            <!-- <select name="" id="" formControlName="requestedUOM" class="form-control">
          <option value="" selected disabled> -- select uom --</option>
          <option value="{{list.uomName}}" *ngFor="let list of uomData">{{list.uomName}}</option>
        </select> -->
          </div>

          <div class="col-lg-6 col-md-6" *ngIf="isRequestedUOM">
            <label>UOM</label>
            <select name="" id="" formControlName="requestedUOM" class="form-control">
              <option value="" selected disabled> -- select uom --</option>
              <option value="{{list.uomName}}" *ngFor="let list of uomData">{{list.uomName}}</option>
            </select>
          </div>

          <div class="col-lg-12 col-md-12">
            <label>Description</label>
            <textarea name="" id="" formControlName="description" class="form-control no-resize"></textarea>
          </div>



        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" (click)="remove()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="objectAllocationRegister()" class="btn btn-primary">{{ 'generic.add' |
            translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="clearData()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
        <div class="modal-footer">
          <button type="button" id="closeModalDelete" (click)="clearData()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="deleteObjectAllocationRegister()" class="btn btn-primary">{{ 'generic.delete' |
            translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content" *ngFor="let viewData of singleObjectAllocationRegisterData">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-allocation-register.headings.detail' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="service-data">
          <div class="form-group">
            <!-- <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.givenName' | translate }} :</label>
                <p>{{viewData.givenName || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.objectSerialNo' | translate }} :</label>
                <p>{{viewData.objectSerialNo || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.issuedToUserName' | translate }} :</label>
                <p>{{viewData.issuedToUserName || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.issuedByUserName' | translate }} :</label>
                <p>{{viewData.issuedByUserName || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.issuedDate' | translate }} :</label>
                <p>{{viewData.issuedDate || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.returnedOn' | translate }} :</label>
                <p>{{viewData.returnedOn || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.remarks' | translate }} :</label>
                <p>{{viewData.remarks || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.description' | translate }} :</label>
                <p>{{viewData.description || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-allocation-register.latestStatus' | translate }} :</label>
                <p style="text-transform: lowercase; text-transform: capitalize;">{{(viewData.latestStatus || '--').toLowerCase()}}</p>
              </div>

              <div class="col-md-12 col-lg-12">
                <div class="status-table">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 50%;">{{ 'object-allocation-register.userId' | translate }}</th>
                        <th style="width: 20%;text-align: center;">{{ 'object-allocation-register.issueStatus' | translate }}</th>
                        <th style="width: 30%;text-align: center;">{{ 'object-allocation-register.updatedDate' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let status of viewData.status">
                        <td style="width: 50%;">{{status.userId}}</td>
                        <td style="width: 20%;text-align: center;">{{status.issueStatus}}</td>
                        <td style="width: 30%;text-align: center;">{{status.updatedDate | date:'medium'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" *ngIf="isStatusUpdate">
                <div class=" update-status-block">
                  <h5>Update Status</h5>
                  <div class="update-status">
                    <div>
                      <label for="">Status</label>
                      <select style="text-align: center;margin-bottom: 0;margin-right: 10px;" [(ngModel)]="issueStatus" name="" id="" class="form-control">
                        <option value="ALL"> -- status --</option>
                        <option value="{{list}}" style="text-transform: capitalize;" *ngFor="let list of statusList">{{list}}</option>
                      </select>
                    </div>

                    <div class="status-action">
                      <button type="button" class="btn btn-secondary" (click)="changeStatusClick()" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                      <button type="button" class="btn btn-primary" (click)="allocationStatusUpdate()">{{ 'generic.update' | translate }}</button>
                    </div>
                    
                  </div>
                </div>
                
              </div>
            </div>  -->

            <div class="row">


              <div class="col-md-6 col-lg-6">
                <label>Allocation Register ID :</label>
                <p>{{ viewData?.objectAllocationRegisterId || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Template Name :</label>
                <p>{{ viewData?.objectTemplateName || '--' }}</p>
              </div>

              <!-- <div class="col-md-6 col-lg-6">
    <label>Requested By :</label>
    <p>{{ viewData?.requestedByUserName || '--' }}</p>
  </div>

  <div class="col-md-6 col-lg-6">
    <label>Requested Date :</label>
    <p>{{ viewData?.requestedDate || '--' }}</p>
  </div>

  <div class="col-md-6 col-lg-6">
    <label>Requested Quantity :</label>
    <p>{{ viewData?.requestedQuantity || '--' }} {{ viewData?.requestedUOM || '' }}</p>
  </div>

  <div class="col-md-6 col-lg-6">
    <label>Approved By :</label>
    <p>{{ viewData?.approvedUserName || '--' }}</p>
  </div>

  <div class="col-md-6 col-lg-6">
    <label>Approved Date :</label>
    <p>{{ viewData?.approvedDate || '--' }}</p>
  </div>

  <div class="col-md-6 col-lg-6">
    <label>Approved Quantity :</label>
    <p>{{ viewData?.approvedQuantity || '--' }} {{ viewData?.approvedUOM || '' }}</p>
  </div>

  <div class="col-md-6 col-lg-6" *ngIf="viewData.qty">
    <label>Issued Quantity :</label>
    <p>{{ viewData?.issuedQty || '--' }}</p>
  </div>

    <div class="col-md-6 col-lg-6" *ngIf="viewData.qty">
    <label>Deployed Quantity :</label>
    <p>{{ viewData?.deployedQty || '--' }}</p>
  </div> -->



              <div class="col-md-6 col-lg-6">
                <label>Country :</label>
                <p>{{ viewData?.country || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Province/State :</label>
                <p>{{ viewData?.provinceOrState || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>District :</label>
                <p>{{ viewData?.district || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Zone :</label>
                <p>{{ viewData?.zone || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Postal Code :</label>
                <p>{{ viewData?.postalCode || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>City :</label>
                <p>{{ viewData?.city || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Location :</label>
                <p>{{ viewData?.location || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Last Returned On :</label>
                <p>{{ viewData?.returnedOn | date}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Remarks :</label>
                <p>{{ viewData?.remarks || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Latest Status :</label>
                <p>{{ getStatus(viewData?.latestStatus) }}</p>
              </div>


              <div class="col-md-6 col-lg-6">
                <label>Created By :</label>
                <p>{{ viewData?.createdByUserName || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Created Date :</label>
                <p>{{ viewData?.createdDate | date }}</p>
              </div>

              <div class="col-md-12 col-lg-12">
                <label>Description :</label>
                <p>{{ viewData?.description || '--' }}</p>
              </div>



              <div class="col-md-12 col-lg-12">
                <div class="section-block-1">

                  <div class="row">

                    <div class="col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Requested By :</label>
                        <p>{{ viewData?.requestedByUserName || '--' }}</p>
                      </div>
                    </div>

                    <div class="col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Requested Date :</label>
                        <p>{{ viewData?.requestedDate || '--' }}</p>
                      </div>
                    </div>

                    <div class="col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Requested Quantity :</label>
                        <p>
                          {{ viewData?.requestedQuantity || '--' }}
                          {{ viewData?.requestedUOM || '' }}
                        </p>
                      </div>
                    </div>

                    <div class="col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Approved By :</label>
                        <p>{{ viewData?.approvedUserName || '--' }}</p>
                      </div>
                    </div>

                    <div class="col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Approved Date :</label>
                        <p>{{ viewData?.approvedDate || '--' }}</p>
                      </div>
                    </div>

                    <div class="col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Approved Quantity :</label>
                        <p>
                          {{ viewData?.approvedQuantity || '--' }}
                          {{ viewData?.approvedUOM || '' }}
                        </p>
                      </div>
                    </div>

                    <div class="col-md-4 col-lg-4" *ngIf="viewData?.qty">
                      <div class="form-group">
                        <label>Issued Quantity :</label>
                        <p>{{ viewData?.issuedQty || '--' }}</p>
                      </div>
                    </div>

                    <div class="col-md-4 col-lg-4" *ngIf="viewData?.qty">
                      <div class="form-group">
                        <label>Deployed Quantity :</label>
                        <p>{{ viewData?.deployedQty || '--' }}</p>
                      </div>
                    </div>

                  </div>
                </div>

              </div>


              <div class="col-md-12 col-lg-12">
                <div class="status-table">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 20%;">{{ 'object-allocation-register.userId' | translate }}</th>
                        <th style="width: 40%;text-align: center;">{{ 'object-allocation-register.issueStatus' |
                          translate }}</th>
                        <th style="width: 40%;text-align: center;">{{ 'object-allocation-register.updatedDate' |
                          translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let status of viewData.status">
                        <td style="width: 20%;">{{status.userId}}</td>
                        <td style="width: 40%;text-align: center;">{{getStatus(status?.issueStatus)}}</td>
                        <td style="width: 40%;text-align: center;">{{status.updatedDate | date:'medium'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>


              <div class="col-md-12 col-lg-12" *ngIf="viewData.bulkObjects && viewData.bulkObjects.length != 0">
                <h3 class="title-header">Asset Info </h3>
                <div class="section-block">

                  <div class="section" *ngFor="let object of viewData.bulkObjects; let i = index">

                    <div class="nested-group">

                      <div class="row">


                        <div class="col-md-6 col-lg-6">
                          <div class="form-group">
                            <label>Asset Id:</label>
                            <p>{{object.objectId || " -- "}}</p>
                          </div>
                        </div>

                        <div class="col-md-6 col-lg-6">
                          <div class="form-group">
                            <label>Name:</label>
                            <p>{{object.objectGivenName || " -- "}}</p>
                          </div>
                        </div>

                        <div class="col-md-6 col-lg-6">
                          <div class="form-group">
                            <label>Serial No:</label>
                            <p>{{object.objectSerialNo || " -- "}}</p>
                          </div>
                        </div>


                        <div class="col-md-6 col-lg-6">
                          <div class="form-group">
                            <label>Issued By:</label>
                            <p>{{object.issuedByUserName || " -- "}}</p>
                          </div>
                        </div>

                        <div class="col-md-6 col-lg-6">
                          <div class="form-group">
                            <label>Status:</label>
                            <p>{{getStatus(object.latestStatus)}}</p>
                          </div>
                        </div>

                        <div class="col-md-6 col-lg-6" *ngIf="viewData.qty">
                          <div class="form-group">
                            <label>Issued Qty:</label>
                            <p>{{object.tobeIssuedQty || " -- "}}</p>
                          </div>
                        </div>

                        <div class="col-md-6 col-lg-6" *ngIf="viewData.qty">
                          <div class="form-group">
                            <label>Deployed Qty:</label>
                            <p>{{object.deployedQty || " -- "}}</p>
                          </div>
                        </div>

                        <div class="col-md-6 col-lg-6" *ngIf="viewData.qty">
                          <div class="form-group">
                            <label>Returned Qty:</label>
                            <p>{{object.returnedQty || " -- "}}</p>
                          </div>
                        </div>


                        <div class="col-md-6 col-lg-6">
                          <div class="form-group">
                            <label>Issued Date:</label>
                            <p>{{object.issuedDate || " -- "}}</p>
                          </div>
                        </div>


                        <div class="col-md-12 col-lg-12">
                          <div class="status-table">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th style="width: 35%;">Name</th>
                                  <th style="width: 30%;text-align: center;">Status</th>
                                  <th style="width: 35%;text-align: center;">Updated Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let list of object.status">
                                  <td style="width: 35%;">{{list.name}}</td>
                                  <td style="width: 30%;text-align: center;">{{getStatus(list.issueStatus)}}</td>
                                  <td style="width: 35%;text-align: center;">{{list.updatedDate | date}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div class="col-md-12 col-lg-12"
                          *ngIf="object.latestStatus == 'RETURNED' && actionControls.isIssue">
                          <div class="status-action">
                            <button type="button" class="btn btn-primary"
                              (click)="updateObjectAllocationRegisterForObjectsOnceAtATime('RETURN_RECEIVED',object)">{{
                              'generic.received' | translate }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>



              <div class="col-md-12 col-lg-12" *ngIf="isStatusUpdate">
                <div class=" update-status-block">
                  <h5>Update Status</h5>
                  <div class="update-status">
                    <div>
                      <label for="">Status</label>
                      <select style="text-align: center;margin-bottom: 0;margin-right: 10px;" [(ngModel)]="issueStatus"
                        name="" id="" class="form-control">
                        <option value="ALL"> -- status --</option>
                        <option value="{{list}}" style="text-transform: capitalize;" *ngFor="let list of statusList">
                          {{list}}</option>
                      </select>
                    </div>

                    <div class="status-action">
                      <button type="button" class="btn btn-secondary" (click)="changeStatusClick()"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                      <button type="button" class="btn btn-primary" (click)="allocationStatusUpdate()">{{
                        'generic.update' | translate }}</button>
                    </div>

                  </div>
                </div>

              </div>




              <div class="col-md-12 col-lg-12" *ngIf="isApproveUpdate">
                <div class=" update-status-block">
                  <h5>Approve</h5>
                  <div class="update-status">
                    <div>
                      <label for="">Quantity <span class="required">*</span></label>
                      <input type="text" (drop)="false" (copy)="false" (paste)="false"
                        (contextmenu)="$event.preventDefault()" (cut)="false"
                        (keydown)="filterInputByType($event, 'number')" [(ngModel)]="approvedQuantity" name="" id=""
                        class="form-control">
                    </div>

                    <div>
                      <label for="">Remarks</label>
                      <input type="text" [(ngModel)]="remarks" name="" id="" class="form-control">
                    </div>

                    <div class="status-action">
                      <button type="button" class="btn btn-secondary" (click)="approveClick()" data-dismiss="modal">{{
                        'generic.cancel' | translate }}</button>
                      <button type="button" class="btn btn-primary"
                        (click)="updateObjectAllocationRegisterForApproval()">{{ 'generic.approve' | translate
                        }}</button>
                    </div>

                  </div>
                </div>

              </div>


              <div class="col-md-12 col-lg-12" *ngIf="isReject">
                <div class=" update-status-block">
                  <h5>Reject</h5>
                  <div class="update-status">

                    <div>
                      <label for="">Remarks</label>
                      <input type="text" [(ngModel)]="remarks" name="" id="" class="form-control">
                    </div>

                    <div class="status-action">
                      <button type="button" class="btn btn-secondary" (click)="rejectClick()" data-dismiss="modal">{{
                        'generic.cancel' | translate }}</button>
                      <button type="button" class="btn btn-primary" (click)="updateAllocationStatus('REJECTED')">{{
                        'generic.reject' | translate }}</button>
                    </div>

                  </div>
                </div>

              </div>


              <div class="col-md-12 col-lg-12" *ngIf="isIssued">
                <div class=" update-status-block">
                  <h5>Issue Assets</h5>
                  <div class="update-status">
                    <div>
                      <label for=""
                        style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                        <span>Asset <span class="required">*</span></span>
                      </label>
                      <input type="text" id="scanner-input"
                        style="position: absolute; opacity: 0; height: 0; width: 0; border: none;"
                        (keyup.enter)="onScannerInput($event)" />
                      <ng-multiselect-dropdown [placeholder]="'select asset'" [settings]="issuedDropdownSettings"
                        [data]="objectInfoListByTemplateNameAndLocation" [(ngModel)]="issuedSelectedList"
                        class="form-control" style="padding: 0;border: none" [ngModelOptions]="{standalone: true}"
                        (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)"
                        (onSelectAll)="onSelectAll($event)">
                      </ng-multiselect-dropdown>
                    </div>


                    <div class="asset-select-list">
                      <p *ngFor="let list of issuedSelectedListWithDetail">{{list.nameAndAvailableQty}}
                        <input *ngIf="list.tobeIssuedQty || list.tobeIssuedQty == '' || list.tobeIssuedQty == 0"
                          [(ngModel)]="list.tobeIssuedQty" [value]="list.tobeIssuedQty" type="text">
                      </p>
                    </div>


                    <div class="status-action">
                      <button type="button" class="btn btn-secondary" (click)="issuedClicked()" data-dismiss="modal">{{
                        'generic.cancel' | translate }}</button>
                      <button type="button"
                        *ngIf="objectInfoListByTemplateNameAndLocation && objectInfoListByTemplateNameAndLocation.length != 0"
                        class="btn btn-primary" (click)="updateObjectAllocationRegisterForIssue()">{{ 'generic.issue' |
                        translate }}</button>
                    </div>

                  </div>
                </div>



              </div>


            </div>

          </div>
        </div>
        <div class="modal-status">
          <!-- <div class="footer-status-block" *ngIf="viewData.latestStatus && viewData.latestStatus != 'REQUESTED'">
            <select style="text-align: center;margin-bottom: 0;margin-right: 10px;" (change)="statusChanged($event)" [(ngModel)]="viewData.latestStatus">
              <option value="{{list}}" style="text-transform: capitalize;" *ngFor="let list of updateStatusList">{{list}}</option>
            </select>
            <button (click)="allocationStatusUpdate()" *ngIf="!isIssued" class="btn btn-primary">{{ 'generic.submit' | translate }}</button>
          </div> -->

          <div class="footer-status-block">
            <button
              *ngIf="viewData.latestStatus && viewData.latestStatus == 'REQUESTED' && !isReject && !isIssued && !isApproveUpdate && actionControls.isApprove"
              (click)="approveClick()" class="btn btn-primary">{{ 'generic.approve' | translate }}</button>
            <button
              *ngIf="viewData.latestStatus && viewData.latestStatus == 'REQUESTED'  && !isReject && !isIssued && !isApproveUpdate && actionControls.isApprove"
              (click)="rejectClick()" class="btn btn-primary">{{ 'generic.reject' | translate }}</button>
            <button
              *ngIf="viewData.latestStatus && (viewData.latestStatus == 'APPROVED' || viewData.latestStatus == 'PARTIALLY_ISSUED')  && !isReject && !isIssued && !isApproveUpdate && actionControls.isIssue"
              (click)="issuedClicked()" class="btn btn-primary">{{ 'generic.issue' | translate }}</button>
          </div>

          <!-- <div class="footer-status-block">
            <button *ngIf="viewData.latestStatus && viewData.latestStatus == 'REQUESTED' && !isReject && !isIssued && !isApproveUpdate" (click)="approveClick()" class="btn btn-primary">{{ 'generic.approve' | translate }}</button>
            <button *ngIf="viewData.latestStatus && viewData.latestStatus == 'REQUESTED'  && !isReject && !isIssued && !isApproveUpdate" (click)="rejectClick()" class="btn btn-primary">{{ 'generic.reject' | translate }}</button>
            <button *ngIf="viewData.latestStatus && (viewData.latestStatus == 'APPROVED' || viewData.latestStatus == 'PARTIALLY_ISSUED')  && !isReject && !isIssued && !isApproveUpdate" (click)="issuedClicked()" class="btn btn-primary">{{ 'generic.issue' | translate }}</button>
          </div> -->

          <!-- <div class="footer-status-block" *ngIf="viewData.latestStatus && viewData.latestStatus == 'APPROVED'">
            <button (click)="approveClick()" class="btn btn-primary">{{ 'generic.issue' | translate }}</button>
          </div> -->

          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel'
            | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>